export default "__VITE_ASSET__e5c91448__"